import React from "react";
import './css/ScrollToUpButton.css';

export const ScrollToUpButton = () => {

    window.onscroll = (): void => {
        if(window.pageYOffset < 150)
        {
            const btn: HTMLElement | null = document.querySelector(".ScrollToUpButton");
            btn!.style.right = "-50px";
            btn!.style.opacity = "0";
        } else {
            const btn: HTMLElement | null = document.querySelector(".ScrollToUpButton");
            btn!.style.right = "10px";
            btn!.style.opacity = "1";
        }
    };

    /**
     * Scrolls page to top
     */
    const scroll = (): void => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    return (
        <div className="ScrollToUpButton" onClick={scroll} >
            <i className="fas fa-arrow-up" />
        </div>
    )
}
